import React, { useContext } from 'react';

import {
	AimOutlined,
	ApiOutlined,
	ClockCircleOutlined,
	ControlOutlined,
	DashboardOutlined,
	EyeOutlined,
	NotificationOutlined,
	ReconciliationOutlined,
	WhatsAppOutlined,
	BlockOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import { checkRole } from 'src/common/helpers/checkRole';
import { useMenuNavigate } from 'src/components/SidebarMenu/hooks';
import { AuthContext } from 'src/AuthProvider';

export default function SidebarMenu() {
	const { user, } = useContext(AuthContext);
	const { navigate, selectedKeys, } = useMenuNavigate();

	let items = [];
	if (checkRole('partner', { user, }) && user?.role === 'partner') {
		items = [
			{
				label: 'Dashboard',
				key: '0.1',
				icon: <DashboardOutlined />,
				onClick: () => navigate([ '0.1', ], '/'),
			},
			{
				label: 'Observadores',
				key: '1',
				icon: <EyeOutlined />,
				children: [
					{
						key: '1.3',
						label: 'Módulos',
						style: {
							display: checkRole('partner', { user, })
								? 'block' : 'none',
						},
						children: [
							{
								key: '1.3.1',
								label: 'Listar',
								onClick: () => navigate([ '1', '1.3', '1.3.1', ], '/observador/modulo/listar'),
							},
							{
								key: '1.3.2',
								label: 'Adicionar',
								onClick: () => navigate([ '1', '1.3', '1.3.2', ], '/observador/modulo/adicionar'),
							},
						],
					},
				],
			},
			{
				label: 'Administração',
				key: '5',
				icon: <ControlOutlined />,
				onClick: undefined,
				children: [
					{
						key: '5.0',
						label: 'Organização',
						onClick: () => navigate([ '5', '5.0', ], '/administracao/organizacao'),
						style: {
							display: user?.org_id && checkRole('admin', { user, }) ? 'block' : 'none',
						},
					},
					{
						key: '5.1',
						label: 'Organizações',
						onClick: () => navigate([ '5', '5.1', ], '/administracao/organizacoes'),
						style: {
							display: checkRole('partner', { user, }) ? 'block' : 'none',
						},
					},
					{
						key: '5.2',
						label: 'Parceiros',
						onClick: () => navigate([ '5', '5.2', ], '/administracao/parceiros'),
						style: {
							display: checkRole('super_admin', { user, }) ? 'block' : 'none',
						},
					},
				],
			},
			{
				label: 'Comunicação',
				key: '2',
				icon: <NotificationOutlined />,
				children: [
					{
						key: '2.1',
						label: 'WhatsApp',
						icon: <WhatsAppOutlined />,
						children: [
							{
								title: 'Configurar Número',
								key: '2.1.3',
								label: 'Configurar Número',
								onClick: () =>
									navigate(
										[ '2', '2.1', '2.1.3', ],
										'/comunicacao/whatsapp/telefone'
									),
							},
						],
					},
				],
			},
		];
	} else if (checkRole('user', { user, }) && user?.role === 'user') {
		items = [
			{
				label: 'Dashboard',
				key: '0.1',
				icon: <DashboardOutlined />,
				onClick: () => navigate([ '0.1', ], '/'),
			},
			{
				label: 'Observadores',
				key: '1',
				icon: <EyeOutlined />,
				children: [
					{
						key: '1.1',
						label: 'Listar',
						onClick: () => navigate([ '1', '1.1', ], '/observador/listar'),
					},
					{
						key: '1.2',
						label: 'Adicionar',
						onClick: () => navigate([ '1', '1.2', ], '/observador/adicionar'),
					},
					{
						key: '1.4',
						label: 'Adicionar grupo de consultas',
						onClick: () => navigate([ '1', '1.4', ], '/observador/grupo/adicionar'),
					},
				],
			},
		];
	} else {
		// menu completo para outros roles
		items = [
			{
				label: 'Dashboard',
				key: '0.1',
				icon: <DashboardOutlined />,
				onClick: () => navigate([ '0.1', ], '/'),
			},
			{
				label: 'Indicadores',
				key: '0.5',
				icon: <ReconciliationOutlined />,
				onClick: () => navigate([ '0.5', ], '/indicadores/listar'),
			},
			{
				label: 'Observadores',
				key: '1',
				icon: <EyeOutlined />,
				children: [
					{
						key: '1.1',
						label: 'Listar',
						onClick: () => navigate([ '1', '1.1', ], '/observador/listar'),
					},
					{
						key: '1.2',
						label: 'Adicionar',
						onClick: () => navigate([ '1', '1.2', ], '/observador/adicionar'),
					},
					{
						key: '1.4',
						label: 'Adicionar grupo de consultas',
						onClick: () => navigate([ '1', '1.4', ], '/observador/grupo/adicionar'),
					},
					{
						key: '1.3',
						label: 'Módulos',
						style: {
							display: checkRole('partner', { user, })
								? 'block' : 'none',
						},
						children: [
							{
								key: '1.3.1',
								label: 'Listar',
								onClick: () => navigate([ '1', '1.3', '1.3.1', ], '/observador/modulo/listar'),
							},
							{
								key: '1.3.2',
								label: 'Adicionar',
								onClick: () => navigate([ '1', '1.3', '1.3.2', ], '/observador/modulo/adicionar'),
							},
						],
					},
				],
			},
			{
				label: 'Comunicação',
				key: '2',
				icon: <NotificationOutlined />,
				style: {
					display: checkRole('admin', { user, })
						? 'block' : 'none',
				},
				children: [
					{
						key: '2.1',
						label: 'WhatsApp',
						icon: <WhatsAppOutlined />,
						children: [
							{
								key: '2.1.1',
								label: 'Listar Grupos',
								onClick: () =>
									navigate(
										[ '2', '2.1', '2.1.1', ],
										'/comunicacao/whatsapp/grupos/listar'
									),
							},
							{
								title: 'Adicionar Grupos',
								key: '2.1.2',
								label: 'Adicionar Grupos',
								onClick: () =>
									navigate(
										[ '2', '2.1', '2.1.2', ],
										'/comunicacao/whatsapp/grupos/adicionar'
									),
							},
							{
								title: 'Configurar Número',
								key: '2.1.3',
								label: 'Configurar Número',
								style: {
									display: checkRole('admin', { user, }) ? 'block' : 'none',
								},
								onClick: () =>
									navigate(
										[ '2', '2.1', '2.1.3', ],
										'/comunicacao/whatsapp/telefone'
									),
							},
						],
					},
					{
						disabled: true,
						title: 'Em breve...',
						key: '2.3',
						label: 'Webhook',
						icon: <ApiOutlined />,
						onClick: () => navigate([ '2.3', ], '/comunicacao/webhook'),
					},
				],
			},
			{
				label: 'Cron',
				key: '3',
				icon: <ClockCircleOutlined />,
				style: {
					display: checkRole('admin', { user, })
						? 'block' : 'none',
				},
				children: [
					{
						key: '3.1',
						label: 'Listar ',
						onClick: () => navigate([ '3', '3.1', ], '/cron/listar'),
					},
					{
						key: '3.2',
						label: 'Adicionar',
						onClick: () => navigate([ '3', '3.2', ], '/cron/adicionar'),
					},
				],
			},
			{
				label: 'Severidade',
				key: '4',
				icon: <AimOutlined />,
				style: {
					display: checkRole('admin', { user, })
						? 'block' : 'none',
				},
				children: [
					{
						key: '4.1',
						label: 'Listar',
						onClick: () => navigate([ '4', '4.1', ], '/severidade/listar'),
					},
					{
						key: '4.2',
						label: 'Adicionar',
						onClick: () => navigate([ '4', '4.2', ], '/severidade/adicionar'),
					},
				],
			},
			{
				label: 'Administração',
				key: '5',
				icon: <ControlOutlined />,
				style: {
					display: checkRole('admin', { user, })
						? 'block' : 'none',
				},
				children: [
					{
						key: '5.0',
						label: 'Organização',
						onClick: () =>
							navigate([ '5', '5.0', ], '/administracao/organizacao'),
						style: {
							display: user?.org_id && checkRole('admin', { user, })
								? 'block' : 'none',
						},
					},
					{
						key: '5.1',
						label: 'Organizações',
						onClick: () => navigate([ '5', '5.1', ], '/administracao/organizacoes'),
						style: {
							display: checkRole('partner', { user, })
								? 'block' : 'none',
						},
					},
					{
						key: '5.2',
						label: 'Parceiros',
						onClick: () =>
							navigate([ '5', '5.2', ], '/administracao/parceiros'),
						style: {
							display: checkRole('super_admin', { user, })
								? 'block' : 'none',
						},
					},
				],
			},
			{
				key: '6',
				label: 'Store',
				icon: <BlockOutlined />,
				onClick: () => navigate([ '6', ], '/store'),
				style: {
					display: checkRole('user', { user, })
						? 'block' : 'none',
				},
			},
		];
	}

	return (
		<Menu
			theme='dark'
			mode='inline'
			selectedKeys={selectedKeys}
			items={items}
		/>
	);
}
